<template>
  <div class="page-recover">
    <div class="recover-box">
      <div class="recover-logo" @click="$router.push('/')">
        <img src="@/assets/images/layouts/logo_red.png"/>
      </div>
      <div class="recover-container">
        <el-form ref="recoverForm" :model="form" label-width="80px">
          <div class="recover-title">
            <span>Recover Account</span>
          </div>
          <div class="recover-sub-title">
            <span>Enter your email</span>
          </div>
          <el-input type="text" placeholder="Email" v-model="form.email" class="recover-input" />
          <el-button v-on:click="recover" class="recover-btn" :loading="loadingRecover">Reset Password</el-button>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Recover',
  components: {
  },
  data () {
    return {
      form: {
        email: ''
      },
      loadingRecover: false
    }
  },
  methods: {
    recover () {
      const { email } = this.form
      if (email.length <= 0) {
        this.$message.warning('Email is required')
        return
      }
      this.loadingRecover = true
      const url = '/api/v1/atk_player/users/reset_password'
      const that = this
      const body = { email }
      this.$service.post(url, body).then(function (res) {
        if (res.code === 200) {
          that.$router.push('/login')
          that.$message({ type: 'success', message: 'Email verified! We sent you an email with the next steps', duration: 16000 })
        } else {
          that.$message({ type: 'error', message: res.msg })
        }
        that.loadingRecover = false
      }).catch(function (err) {
        console.error('recover', err)
        that.$message({ type: 'error', message: err.msg })
        that.loadingRecover = false
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page-recover {
  padding: 10px;
  min-height: 100vh;
  background: #242A34;
  background-image: url('~@/assets/images/users/bg.png');
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  .recover-box {
    width: 500px;
    margin: 6% auto 0;
    background-color: rgba(46, 54, 68, 0.4);
    border-radius: 10px;
    color: white;
    padding: 50px;
    .recover-logo {
      cursor: pointer;
      margin-bottom: 20px;
      img {
        width: 150px;
        margin: auto;
      }
    }
    .recover-container {
      padding: 20px;
      border-top: 0;
      color: #666;
      .recover-title {
        margin-bottom: 36px;
        text-align: center;
        color: $theme;
        font-size: 30px;
        font-weight: 300;
      }
      .recover-sub-title {
        margin-bottom: 30px;
        text-align: center;
        color: white;
        font-size: 20px;
      }
      .recover-input {
        margin-bottom: 26px;
        input {
          color: #C4C4C4;
          background-color: rgba(85,94,102,0.4);
          border-color: #A6ABAF;
          box-shadow: none;
          height: 35px;
          line-height: 35px;
          padding: 5px 6px;
        }
      }
      .recover-btn {
        width: 100%;
        margin-top: 5px;
        text-transform: uppercase;
        font-weight: 300;
        letter-spacing: 0.5px;
        background-color: red;
        border-color: red;
        height: 35px;
        min-height: auto;
        padding: 0;
        color: white;
      }
    }
  }
}
</style>
